import React from 'react';
import { IconType } from 'react-icons';

interface ContactCardProps {
  Icon: IconType;
  text: string;
  link: string;
}

const ContactCard: React.FC<ContactCardProps> = ({ Icon, text, link }) => {
  return (
    <div className="flex justify-center bg-white bg-opacity-5 transition hover:bg-opacity-15 p-4 rounded-lg shadow-custom w-[90%] h-[90%] my-4">
      <div className="flex flex-row md:flex-col items-center justify-between lg:justify-around w-[100%] gap-4">
        <Icon className="w-16 h-16 text-customGreen" />
        <a href={link} className="text-center text-[10px] md:text-[15px] text-white hover:text-customGreen transition">{text}</a> {/* Aggiunto effetto hover */}
      </div>
    </div>
  );
};

export default ContactCard;
